import { Text } from '@chakra-ui/react';

export const SubmitErrorComponent = (props: any) => (
   <Text className="formManagerStatus">{props.error}</Text>
);
